var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn btn-info",on:{"click":_vm.getLocation}},[_vm._v(" Solicitar ubicación ")]),_c('p',{attrs:{"id":"myPos"}})])}
var staticRenderFns = []

export { render, staticRenderFns }